export default function sortStrings(arr: string[] | undefined | null): string[] {
  if (!arr) return [];
  return [...arr].sort((a, b) => a.localeCompare(b));
}
